import { addressValidation, toWCSMapping, validate as addressValidate } from '@ynap/address-form-v1'
import { raygun } from '@ynap/clientside-monitoring'
import { getLocale } from '@ynap/cart-state'
import { getCurrentShippingAddress } from '../selectors/getShippingAddressStep'
import { SHIPPING_ADDRESS_VALID, SHIPPING_ADDRESS_INVALID } from '../constants/ActionTypes'

export async function isAddressValid(currentAddress, country, config, messages) {
    try {
        const addressValidationOptions = await addressValidation({ countryCode: country, config, countries: [] })
        const { fields } = addressValidationOptions[country] || {}

        if (!fields) {
            return false
        }

        const fieldsWCS = fields
            .filter((field) => field.type.toString().toLowerCase() != 'country')
            .map((field) => ({ ...field, wcsType: toWCSMapping(field.type) }))

        const shouldValidateNonLatin = !config?.head?.addressValidationOptions?.nonLatinValidationBlocklist?.includes(country)

        const validatedFields = fieldsWCS
            .map((field) => {
                const fieldValue = (field.wcsType.accessor ? field.wcsType.accessor(currentAddress) : currentAddress[field.wcsType.name]) || ''
                // allow province/state field to have non-latin characters for countries like Japan

                return addressValidate(
                    messages,
                    field,
                    field.wcsType.name,
                    undefined,
                    shouldValidateNonLatin && field.type.toLowerCase() === 'province'
                )(fieldValue)
            })
            .filter((validation) => validation.length > 0)
        return validatedFields.length === 0
    } catch (error) {
        raygun.helpers.agent('send', { error, tags: ['addressValidation'] })
        return true
    }
}

function shippingAddressInvalid() {
    return {
        type: SHIPPING_ADDRESS_INVALID,
    }
}

function shippingAddressValid() {
    return {
        type: SHIPPING_ADDRESS_VALID,
    }
}

export async function isShippingAddressValid(state, dispatch) {
    let isShippingAddressValid = true
    const { country } = getLocale(state)
    let currentShippingAddress = getCurrentShippingAddress(state)

    // validate selected shipping address
    if (typeof currentShippingAddress !== 'undefined' && Object.keys(currentShippingAddress).length > 0) {
        const { messages, config } = state
        const validationShippingAddress = {
            ...currentShippingAddress,
            addressType: 'ShippingAndBilling',
        }

        isShippingAddressValid = await isAddressValid(validationShippingAddress, country, config, messages)

        if (isShippingAddressValid) {
            dispatch(shippingAddressValid())
        } else {
            raygun.helpers.agent('send', { error: new Error('Shipping Address invalid'), tags: ['fastCheckout', 'addressValidation'] })
            dispatch(shippingAddressInvalid())
        }
    }
}

export async function isBillingAddressValid(currentAddress, config, messages) {
    return new Promise((resolve, reject) => {
        return addressValidation({ countryCode: currentAddress.country, config, countries: [] })
            .then((validation) => {
                const { fields } = validation[currentAddress.country]
                if (!fields) {
                    return false
                }

                const fieldsWCS = fields
                    .filter((field) => field.type.toString().toLowerCase() != 'country')
                    .map((field) => ({ ...field, wcsType: toWCSMapping(field.type) }))

                const shouldValidateNonLatin = !config?.head?.addressValidationOptions?.nonLatinValidationBlocklist?.includes(currentAddress.country)

                const validatedFields = fieldsWCS
                    .map((field) => {
                        const fieldValue = (field.wcsType.accessor ? field.wcsType.accessor(currentAddress) : currentAddress[field.wcsType.name]) || ''
                        const errorMessages = addressValidate(
                            messages,
                            field,
                            field.wcsType.name,
                            undefined,
                            shouldValidateNonLatin && field.type.toLowerCase() === 'province'
                        )(fieldValue)
                        return errorMessages.length > 0 ?  field.wcsType.name : undefined
                    })
                    .filter((errors) => errors !== undefined)
                resolve(validatedFields)
            })
            .catch((error) => {
                reject(error)
            })
    })
}